import styled, { css, keyframes } from 'styled-components';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

const animMove = (radius: number) => keyframes`
    from { transform: rotate(0deg) translateX(${radius}px) rotate(0deg); }
    to {  transform: rotate(-360deg) translateX(${radius}px) rotate(360deg); }
`;

const getAimateParams = (duration?: number, delay?: number) => css`
    animation-duration: ${duration || 15}s;
    animation-timing-function: linear;
    animation-delay: ${delay || 1}s;
    animation-iteration-count: infinite;  
    animation-direction: normal; 
    animation-fill-mode: both;  
    animation-play-state: running;
`;

const getAnimationName = (radius: number, duration?: number, delay?: number) => {
    return css`
        transform: translateX(${radius}px);
        animation-name: ${animMove(radius)};
        ${getAimateParams(duration, delay)};
    `;
};

export const ImgContent = styled.div`
    flex: 1 1 1%;
    width: 100%;
    justify-content: center;
    align-items: center;

    @media (max-width: ${breakePoints.mobile}) {
        order: -1;
    }
`;

export const AnimationWrap = styled.div`
    position: relative;
    
    width: 770px;
    height: 433px;

    @media (max-width: ${breakePoints.desktop}) {
        width: 655px;
        height: 368px;
    }

    @media (max-width: ${breakePoints.sDesktop}) {
        width: 600px;
        height: 337px;
    }

    @media (max-width: ${breakePoints.laptop}) {
        width: 471px;
        height: 264px;
    }

    @media (max-width: ${breakePoints.tablet}) {
        width: 400px;
        height: 224px;
    }
`;

export const Image = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
`;

export const CenterImg = styled(Image)``;

const SattelitImage = styled(Image)`
    position: absolute;

    width: 20%;
    height: auto;
`;

export const LeftImg = styled(SattelitImage)`
    left: 10%;
    top: -2%;
    width: 21%;

    ${() => getAnimationName(12, 16, 2)}
`;

export const RightImg = styled(SattelitImage)`
    top: 7%;
    right: 7%;

    ${() => getAnimationName(18, 18, 1)}
`;

export const BottomImg = styled(SattelitImage)`
    left: 37%;
    bottom: -6%;
    width: 17%;

    ${() => getAnimationName(10, 20, 2.5)}
`;
